import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class ShipmentsService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

	loadShipmentsData(): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/shipments/getShipmentsGrid`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	loadSupplierDropDown(): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/shipments/getSuppliers`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}
	loadFreightTypeDropDown(): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/shipments/getFreightTypes`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}
	loadShipmentsTypeDropDown(): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/shipments/getShipmentTypes`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}
	deleteShipments(shipmentId): Observable<any> {

		return this.http
			.delete(`${this.constantsService.baseAPIURL}/export/shipments/deleteShipments/${shipmentId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	deleteInvoices(invoiceId): Observable<any> {

		return this.http
			.delete(`${this.constantsService.baseAPIURL}/export/shipments/deleteShipmentDetails/${invoiceId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	loadShipmentDetailsData(shipmentId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/shipments/getShipmentDetails/${shipmentId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	addShipmentDetails(addObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/export/shipments/addShipmentDetails`, addObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	addEditShipment(addObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/export/shipments/addEditShipment`, addObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	updateshipmentsData(updateObject): Observable<any> {
		return this.http.put(` ${this.constantsService.baseAPIURL}/export/shipments/addEditShipment`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	updateShipmentDetails(updateObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/export/shipments/editShipmentDetails`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}

}
